import { statusFor } from "./pages/components/LeasePortfolioFilters.jsx";
import { fmtKpiUsd } from "../../utils/fmtAbbreviated.js";

// Canonical default for both Leases views and Home's portfolio headline.
export const DEFAULT_LEASE_STATUS_STATUSES = Object.freeze([
  "in_use",
  "pre_commencement",
  "vacant_held",
]);

export function selectDefaultPortfolioLeases(leases, today = new Date()) {
  return leases.filter((lease) => DEFAULT_LEASE_STATUS_STATUSES.includes(statusFor(lease, today)));
}

// Consume resolved Metric A values only. Never recalculate FX or substitute the
// contractualAnnualRentUsd override used by the commitments/exposure panel.
// Deliberately accepts an already-scoped set: Leases retains its filter behavior.
export function deriveAnnualRentKpi(leases) {
  const totalRent = leases.reduce((sum, lease) => sum + (lease.annualRentUsd ?? 0), 0);
  const recoveryRentPartial = leases.some((lease) => lease.recoveryCoverage?.partial);
  const totalGrossRent = leases.reduce((sum, lease) => sum + (lease.grossAnnualRentUsd ?? lease.annualRentUsd ?? 0), 0);
  const totalRecovery = leases.reduce((sum, lease) => sum + (lease.subleaseRecoveryUsd ?? 0), 0);
  const hasRecovery = totalRecovery > 0 || recoveryRentPartial;
  return {
    totalRent, totalGrossRent, totalRecovery, recoveryRentPartial,
    descriptor: recoveryRentPartial
      ? "net recorded · partial recovery coverage"
      : totalRecovery > 0 ? "net recorded, current year, USD" : "base rent, current year, USD",
    description: hasRecovery
      ? "Recorded current-year rent, less eligible recorded sublease income, USD."
      : "Base rent across active leases, current year, USD.",
    recoveryDetail: hasRecovery
      ? `Gross liability ${fmtKpiUsd(totalGrossRent)} · sublease income −${fmtKpiUsd(totalRecovery)}${recoveryRentPartial ? " · Partial recovery coverage; unrecorded income excluded" : ""}`
      : null,
  };
}
